var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-text"},[_c('p',[_vm._v(" "+_vm._s(_vm.footerData.filingInformation || "办学许可证号：豫教民4101000100004 备案号：豫ICP备2022003182号")+" ")]),_c('p',[_vm._v(_vm._s(_vm.footerData.versionInformation || "CopyrightⒸ2004-2019.All Rights Reserved. 郑州健康学院 版权所有"))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }